export default __webpack_public_path__ + "assets/a60564c12343ab2d459a8df0b74f39cd.png";